module.exports = {
  menu: {
    gmBlockingThreshold: 'Blockin\' Threshold',
    lockThePlace: 'Lock your place',
  },
  home: {
    title: 'This site currently contains 2 sections',
    describeGmBlockingThreshold: 'This tool calculates how many FP\'s to add to your GB so you can secure the P1 P2 P3 P4 and P5 to other players based on their bonus.',
    describeLockThePlace: 'This tool allows to know the number of FP to ask on a GB to lock your place as well as to deduce the final balance (gain / loss)',
  },
  gmBlockingThreshold: {
    info: {
      title: 'Info',
      expand: '[click to expand]',
      reduce: '[click to reduce]',
      describeColumns: 'Each column represents the number of FPs to put so that the place you want to offer a player is secured by taking into account the % bonus of his Arc.',
      describeRed: {
        unlockableStart: 'This color means that ',
        unlockableBold: 'you ',
        unlockableEnd: 'must put x FP to secure the place at the selected rate. ',
        middle: 'Your friend will then put ',
        lockable: '(x FP)',
      },
      describeGreen: 'This color means that the player can place x FP and thus lock the place at the selected rate',
      describeClickOnLine: 'Click on a line to highlight it',
      describeCopy: {
        beforeImg: 'Click on ',
        afterImg: 'to copy a promotional message as ',
        promoteExample: 'Zeus (607) 👉 P4(10) P3(29) P2(95) P1(190)'
      }
    },
    select: 'Select a GB',
    th: {
      level: 'Level',
      maxFp: 'Max FP',
      p1: 'P1 at (%)',
      p2: 'P2 at (%)',
      p3: 'P3 at (%)',
      p4: 'P4 at (%)',
      p5: 'P5 at (%)',
      p1To5: {
        line1: 'Put to',
        line2: 'secu from',
        line3: 'P1 to P5'
      }
    },
    results: {
      unlockable: ' $value FP',
      lockable: 'With $value FP',
      tooltip: ' ($value FP)',
      total: '$value FP',
    },
    notification: {
      promotionMessage: 'Promotion level $level copied ! 🎉'
    }
  },
  lockThePlace: {
    maxPf: 'GB Maximum FP',
    totalPfPut: 'Total FP posed on the GB',
    pfToOvertake: 'Nb of FP of the place to overtake',
    pfToEarn: 'Gain of the intended place',
    yourArcBonus: 'Your % gain with Arc bonus (100-200%)',
    ownPfLaid: 'FP that you have already put',
    label: 'Label (optional)',
    impossible: 'Impossible',
    win: 'earned',
    lost: 'lost',
    neededToLock: 'To block the place, put: $toPut FP',
    balanceSheet: 'Balance Sheet: $balanceSheet FP ',
  },
  contact: {
    title: 'Contact',
    content: 'A suggestion? a bug? an observation? a request to add a functionality? Send an email to ',
    curious: 'Curious to discover who\'s behind this site? 🔍',
    portfolioLink: 'Discover'
  },
  gms: {
    Observatory: 'Observatory',
    Temple_of_Relics: 'Temple of Relics',
    Oracle_of_Delphi: 'Oracle of Delphi',
    Galata_Tower: 'Galata Tower',
    Tower_of_Babel: 'Tower of Babel',
    Statue_of_Zeus: 'Statue of Zeus',
    Colosseum: 'Colosseum',
    Lighthouse_of_Alexandria: 'Lighthouse of Alexandria',
    Hagia_Sophia: 'Hagia Sophia',
    Cathedral_of_Aachen: 'Cathedral of Aachen',
    St_Mark_s_Basilica: 'St. Mark\'s Basilica',
    Notre_Dame: 'Notre Dame',
    Saint_Basil_s_Cathedral: 'St. Basil\'s Cathedral',
    Castel_del_Monte: 'Castel del Monte',
    Deal_Castle: 'Deal Castle',
    Frauenkirche_of_Dresden: 'Frauenkirche of Dresden',
    Capitol: 'Capitol',
    Royal_Albert_Hall: 'Royal Albert Hall',
    Chateau_Frontenac: 'Château Frontenac',
    Alcatraz: 'Alcatraz',
    Space_Needle: 'Space Needle',
    Atomium: 'Atomium',
    Cape_Canaveral: 'Cape Canaveral',
    The_Habitat: 'The Habitat',
    Lotus_Temple: 'Lotus Temple',
    Innovation_Tower: 'Innovation Tower',
    Truce_Tower: 'Truce Tower',
    Voyager_V1: 'Voyager V1',
    The_Arc: 'The Arc',
    Rain_Forest_Project: 'Rain Forest Project',
    Gaea_Statue: 'Gaea Statue',
    Arctic_Orangery: 'Arctic Orangery',
    Seed_Vault: 'Seed Vault',
    Atlantis_Museum: 'Atlantis Museum',
    The_Kraken: 'The Kraken',
    The_Blue_Galaxy: 'The Blue Galaxy',
    Terracotta_Army: 'Terracotta Army',
    Himeji_Castle: 'Himeji Castle',
    The_Virgo_Project: 'The Virgo Project',
    Star_Gazer: 'Star Gazer',
    Space_Carrier: 'Space Carrier',
    Flying_Island: 'Flying Island',
    AI_Core: 'A.I. Core',
    Saturn_VI_Gate_CENTAURUS: 'Saturn VI Gate CENTAURUS',
    Saturn_VI_Gate_PEGASUS: 'Saturn VI Gate PEGASUS',
    Saturn_VI_Gate_HYDRA: 'Saturn VI Gate HYDRA',
    Stellar_Warship: 'Stellar Warship',
    Cosmic_Catalyst: 'Cosmic Catalyst',
  }
}



// WEBPACK FOOTER //
// ./src/locale/languages/en.js